import React from 'react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';

import TreeView from '@zippytech/react-toolkit/TreeView';
import '@zippytech/react-toolkit/TreeView/index.css';

import { Grid } from 'semantic-ui-react';

import ContentTreeMenu from './contentTree';
import LabelWithCount from '../../../common/LabelWithCount';


class LibraryTreeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPath: 0,
      selected: { "0": true }
    };
  }

  componentWillMount() {

    dispatch.lifeCycle.getCategoryAsync({ "accountId": this.props.match.params.accountId });
    dispatch.lifeCycle.getCategoryTreeAsync({ accountId: this.props.match.params.accountId });
    dispatch.lifeCycle.getPublicCategoryTreeAsync();
    let intitiativeCountData = this.props.intitiativeCountData;
    let objValidation = Object.entries(intitiativeCountData).length === 0 && intitiativeCountData.constructor === Object
    if (objValidation) {
      let payload = {};
      payload.organizationId = this.props.selectedOrganisation.id;
      dispatch.initiatives.getinitiativesCount(payload);
    }
    let pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_in/`;
    if(pathName+"draft"== this.props.location.pathname){
      this.setState({ currentPath: "0/0" })
    }else if(pathName+"indesign"==this.props.location.pathname){
      this.setState({ currentPath: "0/1" })
    }else if(pathName+"active"==this.props.location.pathname){
      this.setState({ currentPath: "0/2" })
    }else if(pathName+"closed"==this.props.location.pathname){
      this.setState({ currentPath: "0/3" })
    }else if(pathName+"cancelled"==this.props.location.pathname){
      this.setState({ currentPath: "0/4"})
    }else {this.setState({ currentPath: "0"})}
  }

  nodeStyle = (nodeProps) => {
//KLM-9337
    if (this.state.currentPath == nodeProps.path ) {
      return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
    } else {
      return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }
    }
  }

  onSelectionChange(data) {
    //this.props.setCollapsedResourcePaneIndex(null)
    dispatch.initiatives.setSelectedPlaybookData({});
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.initiatives.showResourecePane(null);

    this.setState({ selected: data });
    if (this.state.currentPath !== data.path) {
      this.setState({ currentPath: data.path });
      dispatch.initiatives.setTreeCurrentPath(data.path);
    }
    // dispatch.initiatives.showResourecePane(null);
    dispatch.initiatives.setSelectedDataById({});
    dispatch.initiatives.initiativeAggangementPane(null);
    const history = this.props.history;
    //change for KLM-9311
    // dispatch.initiatives.isSortingFlag(null);
    dispatch.initiatives.isSortingFlag({key: "subCategory", order: -1 ,text:"Sub Category" });

    let urlPath = ""
    if (data.node.value === 0) {
      urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign'
    } else if (data.node.value === 1) {
      urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/active'
    } else if (data.node.value === 3) {
      urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/closed'
    } else if (data.node.value === 5) {
      urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/cancelled'
    } else if (data.node.value === -1) {
      urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/draft'
    } else {
      urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in'
    }

    history.push({
      pathname: urlPath
    });

    dispatch.lifeCycle.disableLinking();
    dispatch.lifeCycle.setDependencyIcon(false);

  }
  setDataAsPerCategory = async (limit) => {
    setTimeout(() => {
      let payload = {
        organizationId: this.props.selectedOrganisation.id,
        category: this.props.selectedDataById.category,
      }
      if (limit && limit !== 10) {
        payload.limit = limit
          dispatch.initiatives.getPublishedContentDataAsync(payload);
      } else {
        dispatch.initiatives.getPublishedContentDataAsync(payload);
      }

    }, 100);
  }
  componentWillReceiveProps(newProps) {
    let pvtTotalCount = 0
    let publicTotalCount = 0
    if (this.props.categoryTree !== newProps.categoryTree) {
      newProps.categoryTree.map((m, i) => {
        pvtTotalCount = pvtTotalCount + m.totalInitiativeCount

        m.label = <LabelWithCount label={m.label} count={m.totalInitiativeCount} />
        if (m.nodes && m.nodes.length !== 0) {
          m.nodes.map((m1, i) => {
            m1.label = <LabelWithCount label={m1.label} count={m1.totalInitiativeCount} />
            if (m1.nodes && m1.nodes.length !== 0) {
              m1.nodes.map((m2, i) => {
                m2.label = <LabelWithCount label={m2.label} count={m2.totalInitiativeCount} />
                return m2
              })
            }
            return m1
          })
        }
        return m
      })
      this.setState({ pvtTotal: pvtTotalCount })
      this.setState({ pvtCategory: newProps.categoryTree })
    }

    if (this.props.categoryPublicTree !== newProps.categoryPublicTree) {
      newProps.categoryPublicTree.map((m, i) => {
        publicTotalCount = publicTotalCount + m.totalInitiativeCount
        m.label = <LabelWithCount label={m.label} count={m.totalInitiativeCount} />
        if (m.nodes && m.nodes.length !== 0) {
          m.nodes.map((m1, i) => {
            m1.label = <LabelWithCount label={m1.label} count={m1.totalInitiativeCount} />
            if (m1.nodes && m1.nodes.length !== 0) {
              m1.nodes.map((m2, i) => {
                m2.label = <LabelWithCount label={m2.label} count={m2.totalInitiativeCount} />
                return m2
              })
            }
            return m1
          })
        }
        return m
      })
      this.setState({ publicTotal: publicTotalCount })
      this.setState({ publicCategory: newProps.categoryPublicTree })
    }
    this.setState({currentPath:this.props.currentPathValue})
  }

  render() {



    let indesign = this.props.intitiativeCountData && this.props.intitiativeCountData.inDesign;
    let active = this.props.intitiativeCountData && this.props.intitiativeCountData.active;
    // let completed = this.props.intitiativeCountData && this.props.intitiativeCountData.complete;
    let closed = this.props.intitiativeCountData && this.props.intitiativeCountData.closed;
    let cancelled = this.props.intitiativeCountData && this.props.intitiativeCountData.cancelled;
    let draft = this.props.intitiativeCountData && this.props.intitiativeCountData.draft;

    let totalI = indesign + active + closed + cancelled + draft

    let IndesignLabelWithCount = <LabelWithCount label="In Design " count={indesign} />;
    let ActiveLabelWithCount = <LabelWithCount label="Active" count={active} />;
    let ClosedLabelWithCount = <LabelWithCount label="Closed" count={closed} />;
    let CanceledLabelWithCount = <LabelWithCount label="Cancelled" count={cancelled} />;
    let DraftLabelWithCount = <LabelWithCount label="Draft" count={draft} />;


    const initiatives = [
      {
        label: <strong> <LabelWithCount labelClass="bg-blue" label="Initiatives" count={totalI} /> </strong>,
        nodes: [
          {
            label: DraftLabelWithCount,
            value: -1,
          },
          {
            label: IndesignLabelWithCount,
            value: 0,
          },
          {
            label: ActiveLabelWithCount,
            value: 1,
          },
          {
            label: ClosedLabelWithCount,
            value: 3,
          },
          {
            label: CanceledLabelWithCount,
            value: 5,
          }
        ]
      }
      // , {
      //   label: <strong> <LabelWithCount labelClass="bg-blue" label="Workspace Library" count={this.state.pvtTotal} /></strong>,
      //   name: 'knowledgeBank',
      //   nodes: this.state.pvtCategory,
      //   id: 9,
      // },
      // {
      //   label: <strong> <LabelWithCount labelClass="bg-blue" label="Public Library" count={this.state.publicTotal} /> </strong>,
      //   name: 'publicKnowledgeBank',
      //   nodes: this.state.publicCategory,
      //   id: 10,
      // }
    ];

    let draggableMenu = (this.props.activeTab === "configureActivity" || this.props.activeTab === "Progress"
      || this.props.activeTab === "Sequence" || this.props.activeTab === "Teams") ?
      <Grid.Column style={{ height: "100%", overflow: "auto", padding: 0 }}>
        <ContentTreeMenu setDataAsPerCategory={this.setDataAsPerCategory} {...this.props} />
      </Grid.Column> : ''
    return (

      <Grid divided className="practiceTree" columns='equal'>
        <Grid.Row stretched className="pad_0" style={{
          height: "100%",
          overflow: "auto"
        }}>
          <Grid.Column style={{ height: "100%", overflow: "auto", padding: 0 }}>
            <TreeView
              className="browserPane"
              nodeStyle={this.nodeStyle}
              enableSelection={true}
              selected={this.state.selected}
              onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
              dataSource={initiatives}
              singleSelect={true}
              enableHoverStyle={false}
              enableKeyboardNavigation={false}
              defaultCollapsedDepth={1}
            />

          </Grid.Column>
          {draggableMenu ? draggableMenu : ""}

        </Grid.Row>
      </Grid>

    );
  }
}

function mapStateToProps(state) {
  return {
    categoryTree: state.lifeCycle.categoryTree,
    categoryPublicTree: state.lifeCycle.categoryPublicTree,
    createInitiativeCard: state.initiatives.createInitiativeCard,
    publishedContent: state.createPack.publishedContent,
    isDragable: state.lifeCycle.isDragable,
    activeTab: state.initiatives.activeTab,
    activityList: state.lifeCycle.activityList,
    intitiativeCountData: state.initiatives.intitiativeCountData,
    selectedOrganisation: state.app.selectedOrganisation,
  };
}

const connectedLibraryTreeView = connect(mapStateToProps)(LibraryTreeView);

export default connectedLibraryTreeView;